module.exports = __webpack_public_path__ + "static/media/naples.9b1a3f52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/images/naples.jpg
// module id = 1133
// module chunks = 0